import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { SERVER_API_URL } from "../app.constants";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { downgradeInjectable } from "@angular/upgrade/static";

export function initialize(modules: ng.IModule) {
    modules.service(AppSettingsService.Id, downgradeInjectable(AppSettingsService));
}

@Injectable()
export class AppSettingsService {

    public static Id: string = "appSettings";

    private settingsResourceUrl = SERVER_API_URL + 'api/Settings';
    private applicationUserServiceResourceUrl = SERVER_API_URL + 'api/ApplicationUserService';

    constructor(private http: HttpClient) { }

    public getAppSetting(key: string): Observable<HttpResponse<boolean>> {
        return this
            .httpGet<string>(this.settingsResourceUrl, key)
            .pipe(
                map(res => res.clone({ body: res.body === "true"})));
    }

    public getAppSetting2(key: string): Observable<HttpResponse<string>> {
        return this
            .httpGet<string>(this.settingsResourceUrl, key)
            .pipe(
                map(res => res.clone({ body: res.body })));
    }

    private getAuthenticationType(): Observable<HttpResponse<string>> {
        return this
            .httpGet<{ AuthenticationType: string }>(this.applicationUserServiceResourceUrl, "AuthenticationType")
            .pipe(
                map(res => res.clone({ body: res.body.AuthenticationType })));
    }

    public isWindowsAuthentication(): Observable<HttpResponse<boolean>> {
        return this
            .getAuthenticationType()
            .pipe(
                map(res => res.clone({ body: res.body === "Windows" })));
    }

    private httpGet<T>(url: string, key: string): Observable<HttpResponse<T>> {
        return this.http.get<T>(`${url}/${key}`, { observe: 'response' })
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/appsettings.ts